import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { t } from "i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import WarningIcon from "@mui/icons-material/Warning" 

const Delete = ({ id, onDelete }) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteAddress = (addressId) => {
    if (onDelete) {
      onDelete(addressId);
    }
    handleClose();
  };

  return (
    <>
      <Button
        variant="text"
        onClick={handleClickOpen}
        color="error"
        sx={{ mt: "10px" }}
        startIcon={<DeleteIcon />} 
      >
        {t("delete")}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {t("Are you sure you want to delete this address?")}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose}>{t("close")}</Button>
          <Button
            onClick={() => deleteAddress(id)}
            color="error"
            autoFocus
          >
            {t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Delete;
